<template> 
    <div>
        <v-dialog v-model="show" max-width="550" overlay-color="#000" overlay-opacity="0.8" :persistent="loading" :transition="phoneOnly ? 'scroll-x-reverse-transition' : 'dialog-transition'" :fullscreen="phoneOnly" :fluid="phoneOnly" scrollable>
            
            <v-card class="pb-1 px-0 overflow-hidden p-relative has-header" :style="`border-radius: ${phoneOnly ? 0 : 8}px!important`" :class="{'fill-height': phoneOnly}">
                <v-progress-linear v-if="loadingSpinner" :active="loadingSpinner" :indeterminate="loadingSpinner" height="1" absolute top color="white"></v-progress-linear>
                <div :style="statusBarOverlay ? `padding-top: ${statusBarInsetPx+10}px; padding-bottom: ${bottomSafeInsetPx+10}px; ` : ''">

                    <v-toolbar flat fixed class="title-bar surface" height="56" style="border-bottom: 1px solid rgba(0,0,0, 0.08)!important">
                            <v-icon color="transparent" class="pa-2">mdi-arrow-left</v-icon>
                            <v-spacer></v-spacer>
                            <div>
                                <!-- <v-icon color="primary" class="me-2">mdi-play-circle</v-icon> -->
                                <strong class="strong-text--text" style="font-size: 1.1rem">{{lecture.name}}</strong>
                            </div>
                            <v-spacer></v-spacer>
                            <div>
                                <slot name="header-actions" />
                                <v-btn v-haptic icon depressed color="white" @click.stop.prevent="show = false" small dark class="primary">
                                    <!-- <v-icon>mdi-close</v-icon> -->
                                    <v-icon>mdi-chevron-left</v-icon>
                                </v-btn>
                            </div>
                        
                    </v-toolbar>

                    <div v-if="lecture.image_url" class="pa-5">
                        <v-img :src="lecture.image_url" :max-height="pcOnly ? 300 : 220" class="rounded-lg" />
                    </div>
                    <v-tabs v-model="activeTab" color="primary" light grow class="px-0 mx-0 rounded">
                        <v-tab v-haptic href="#videosTab" style="letter-spacing: 0">
                            <v-icon right>mdi-view-list-outline</v-icon>
                            محتويات المحاضرة
                        </v-tab>
                        <v-tab v-haptic href="#descriptionTab" style="letter-spacing: 0">
                            <v-icon right>mdi-text</v-icon>
                            الوصف
                        </v-tab>
                    </v-tabs>
                </div>
                <!-- <v-card-title class="mb-2">
                    <v-icon class="me-2" color="primary">mdi-play-box-multiple-outline</v-icon>
                    الفيديوهات
                </v-card-title> -->
                <!-- <v-card-subtitle></v-card-subtitle> -->
                <v-card-text class="strong-text--text mt-3 px-0" :style="bottomSafeArea ? `padding-bottom: ${bottomSafeInsetPx}px;` : ''">
                    <v-tabs-items v-model="activeTab">
                        <v-tab-item value="videosTab">
                            <!-- <v-alert v-if="!lecture.enable_videos" text dense outlined type="error" icon="mdi-clipboard-text" color="error" class="medium-text font-weight-bold e-link mx-4" v-ripple @click="activeTab = 'examsTab'">
                                لديك امتحانات إجبارية قبل فتح الفيديوهات
                            </v-alert> -->
                            
                            <v-list v-if="items && items.length" class="pa-0 transparent"> 
                                <template v-for="(item, i) in items" >
                                    <v-list-item v-if="item.type === 'exam'" v-haptic :disabled="item.locked" v-ripple="phoneOnly" :key="item.item.id + '-' + i" class="px-7 py-1" :link="phoneOnly">
                                        <v-list-item-icon @click="phoneOnly && !item.locked ? openExam(item.item) : undefined">
                                            <v-icon :color="item.item.needs_attention ? 'error' : 'primary'">mdi-clipboard-text-outline</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content @click="phoneOnly && !item.locked ? openExam(item.item) : undefined">
                                            <v-list-item-title>
                                                {{item.item.name}}
                                            </v-list-item-title>
                                            <v-list-item-subtitle class="text--text d-flex details-text">
                                                <div v-if="item.item.must_pass" class="d-flex">
                                                    <v-icon :color="item.item.needs_attention ? 'error' : 'success darken-1'" size="16" class="me-1">mdi-{{item.item.needs_attention ? 'license' : 'check'}}</v-icon>
                                                    <span :class="{'font-weight-bold': item.item.needs_attention}">النجاح مطلوب</span>
                                                </div>
                                                <div v-else-if="item.item.must_take" class="d-flex">
                                                    <v-icon :color="item.item.needs_attention ? 'error' : 'strong-text'" size="16" class="me-1">mdi-{{item.item.needs_attention ? 'login' : 'check'}}</v-icon>
                                                    <span>دخول الامتحان مطلوب</span>
                                                </div>

                                                <div v-if="item.item.navigate_to_alternative && item.item.alternative_exam" class="d-flex ms-2">
                                                    <v-icon color="primary" size="16" class="me-1">mdi-reload</v-icon>
                                                    <span>تجربة مع امتحان آخر</span>
                                                    <!-- <span>{{item.item.alternative_exam.name}}</span> -->
                                                </div>
                                                <div v-else-if="item.item.questions_count || item.item.questions_count === 0" class="d-flex ms-2">
                                                    <v-icon color="primary" size="16" class="me-1">mdi-file-question-outline</v-icon>
                                                    <span>{{unitFormat(item.item.questions_count, 'سؤال', 'سؤالين', 'أسئلة')}}</span>
                                                </div>
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                        <v-list-item-icon class="ms-0">
                                            <v-icon v-if="item.locked" color="muted">mdi-lock</v-icon>

                                            <v-btn v-else-if="pcOnly" :disabled="openingExam" :color="item.item.navigate_to_alternative ? (item.item.needs_attention ? 'red darken-1' : 'success darken-1') : 'primary'" dark :outlined="!item.item.needs_attention" @click.stop.prevent="openExam(item.item)">
                                                {{item.item.navigate_to_alternative ? 'الامتحان البديل' : 'فتح الامتحان'}}
                                                <v-icon right>mdi-chevron-left</v-icon>
                                            </v-btn>
                                            <v-icon v-else>mdi-arrow-left</v-icon>
                                        </v-list-item-icon>
                                    </v-list-item>
                                    <v-list-item v-else-if="item.type === 'video'" v-haptic :disabled="item.locked || !item.item.viewable" @click="!item.locked ? playVideo(item.item, i) : undefined" v-ripple="phoneOnly" :key="item.item.id + '-' + i" class="px-7 py-1">
                                        <v-list-item-icon>
                                            <v-icon :color="item.item.viewable ? (item.item.views_limit - item.item.counted_views === 1 ? 'error' : (!item.locked && item.item.seen ? 'success' : 'primary')) : ''">{{!item.locked && item.item.seen ? 'mdi-check-circle' : 'mdi-play-box'}}</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                {{item.item.name}}
                                                
                                                <template v-if="!item.item.hide_attendance_chips">
                                                    <v-chip v-if="item.item.attendance_required" label x-small class="strong-text--text px-1 ms-1" color="grey lighten-2"><b class="me-1">*</b>{{item.item.attendance_chip_text || 'أساسي'}}</v-chip>
                                                </template>
                                            </v-list-item-title>
                                            <v-list-item-subtitle class="d-flex" :class="{'details-text': pcOnly, 'x-small-text': phoneOnly}">
                                                <div v-if="!lecture.expired" class="text--text me-2">
                                                    <span v-if="item.locked" class="muted--text">لا يمكنك مشاهدة الفيديو</span>
                                                    <span v-else-if="item.item.views_limit" :class="{'green--text text--darken-2': item.item.counted_views === 0, 'error--text': item.item.views_limit - item.item.counted_views === 1}">
                                                        تبقى <b>{{item.item.views_limit - item.item.counted_views > 0 ? item.item.views_limit - item.item.counted_views : 0}}</b>
                                                        من
                                                        {{unitFormat(item.item.views_limit, 'مشاهدة', 'مشاهدتين', 'مشاهدات')}}
                                                    </span>
                                                    <span v-else>لا يوجد حد للمشاهدات</span>
                                                </div>
                                                <div>
                                                    <span v-if="lecture.expired" class="error--text">
                                                        <v-icon color="error" small class="me-1">mdi-alert-outline</v-icon>
                                                        المحاضرة منتهية الصلاحية
                                                    </span>
                                                    <span v-else-if="lecture.expiry_days" class="orange--text text--darken-2">صالحة لمدة <b>{{unitFormat(lecture.expiry_days, 'يوم', 'يومين', 'أيام')}}</b></span>
                                                </div>
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                        <v-list-item-icon>
                                            <v-icon v-if="item.locked" color="muted">mdi-lock</v-icon>
                                            <v-icon v-else-if="item.item.viewable" color="primary" style="transform: rotate(270deg)">mdi-open-in-new</v-icon>
                                            <v-icon v-else color="warning">mdi-progress-alert</v-icon>
                                        </v-list-item-icon>
                                    </v-list-item>
                                    <v-divider v-if="i < items.length -1" :key="'d-' + i" style="border-color: rgba(0,0,0, 0.08)"></v-divider>
                                </template>
                                
                                <v-divider key="divider" style="border-color: rgba(0,0,0, 0.08)"></v-divider>

                                <template v-for="(attachment, i) in attachments" >
                                    <v-list-item v-haptic :key="attachment.id" :href="attachment.url" download class="px-7 py-1">
                                        <v-list-item-icon>
                                            <v-icon color="strong-text">mdi-paperclip</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title>{{attachment.name}}</v-list-item-title>
                                            <v-list-item-subtitle>
                                                <v-chip dark :color="attachment.meta.extension === 'pdf' ? 'deep-orange' : 'primary'" label small class="me-1">
                                                    <v-icon class="me-1">mdi-file</v-icon>
                                                    {{attachment.meta.extension.toUpperCase()}}
                                                </v-chip>
                                                <v-chip label small class="ltr-dir">
                                                    {{attachment.size}}
                                                </v-chip>
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                        <v-list-item-icon>
                                            <v-btn as="a" icon large color="secondary" @mousedown.stop @mouseover.stop @touchstart.stop @click.stop :href="attachment.url">
                                                <v-icon size="22">mdi-download</v-icon>
                                            </v-btn>
                                        </v-list-item-icon>
                                    </v-list-item>

                                    <v-divider v-if="i < attachments.length -1" :key="'d' + i" style="border-color: rgba(0,0,0, 0.08)"></v-divider>
                                </template>
                            </v-list>
                        </v-tab-item>
                        <v-tab-item value="descriptionTab" class="px-6">
                            <div style="line-height: 2.2; white-space: pre-line;" class="medium-text text--text">{{lecture.description}}</div>
                        </v-tab-item>
                    </v-tabs-items>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="phoneDownloadDialog" max-width="400" overlay-color="#000" overlay-opacity="0.8">
            <v-card>
                <v-card-title class="mb-2">حمل تطبيق الهاتف</v-card-title>
                <v-card-subtitle>لكي تتمكن من مشاهدة المحاضرة؛ يجب عليك تحميل تطبيق الهاتف</v-card-subtitle>
                <v-card-text>
                
                    <div class="d-flex justify-center align-center">
                        <store-badge type="playstore" width="150px" />
                        <store-badge type="appstore" width="120px" />
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
        <video-dialog v-model="showVideoDialog" :video="showVideo" :next="nextVideo" :previous="previousVideo" @playNext="playVideo(nextVideo, nextVideoIndex)" @playPrevious="playVideo(previousVideo, previousVideoIndex)" />
    </div>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import StoreBadge from '../default/store-badge'
import VideoDialog from './video-dialog'

export default {
    props: {
        value: {},
        lecture: {},
        videos: {},
        items: {},
        exams: {},
        attachments: {},
        pay_type: {}
    },
    components: {StoreBadge, VideoDialog},
    data(){
        return {
            activeTab: '',
            show: false,
            loading: false,

            phoneDownloadDialog: false,

            showVideoDialog: false,
            showVideo: null,
            nextVideo: null,
            nextVideoIndex: null,

            previousVideo: null,
            previousVideoIndex: null,

            openingExam: false,
        }
    },
    computed: {
        ...GlobalComputed,
        loadingSpinner(){
            return this.openingExam;
        },
        examsBadge(){
            let count = 0;
            const exams = this.exams ? this.exams : [];
            exams.forEach(exam=>{
                if (exam.needs_attention){
                    count += 1;
                }
            })
            return count;
        },
    },
    watch :{
        show(show){
            if (!show){
                this.$emit('input', false); // close
            }
        },
        value(show){
            this.show = show;
        }
    },
    methods: {
        playVideo(video, i){
            this.show = false;
            let wpEnabled = this.wpEnabled;

            if (this.platform === 'web' && !wpEnabled && !this.miniDerasaPlatform){
                if (this.pcOnly){
                    const apiToken = window.localStorage.getItem('tK'); // user oauth token
                    const deepLinkProtocol = process.env.VUE_APP_DESKTOP_APP_PROTOCOL;
                    const url = `${deepLinkProtocol}://video?videoId=${video.id}&token=${apiToken}`
                    window.open(url, '_self')
                }else{
                    // on phone, open download-phone-app dialog
                    this.phoneDownloadDialog = true;
                }
            }else if (this.platform === 'android' || this.platform === 'ios' || this.miniDerasaPlatform || wpEnabled){
                window.setTimeout(()=>{
                    this.showVideoDialog = true;
                    this.showVideo = video;

                    this.nextVideo = null;
                    this.nextVideoIndex = null;
                    this.previousVideo = null;
                    this.previousVideoIndex = null;

                    if (i+1 < this.items.length){
                        const nextItem = this.items[i+1];
                        if (nextItem.type === 'video' && !nextItem.locked){
                            this.nextVideo = nextItem.item;
                            this.nextVideoIndex = i+1;
                        }
                    }
                    if (i-1 >= 0){
                        const previousItem = this.items[i-1];
                        if (previousItem.type === 'video' && !previousItem.locked){
                            this.previousVideo = previousItem.item;
                            this.previousVideoIndex = i-1;
                        }
                    }
                }, 200);
            }
        },

        openExam(exam){
            const exam_code = exam.navigate_to_alternative && exam.alternative_exam ? exam.alternative_exam.exam_code : exam.exam_code;
            // get exam details
            if (!this.openingExam){
                this.openingExam = true;
                window.axios.get(`/exams/details?exam_code=${exam_code}`).then(response=>{
                    this.openingExam = false;
                    this.show = false;
                    const examData = response.data.data;
                    window.setTimeout(()=>{
                        this.$router.push({name: 'exams', params: {examData: examData}, query: {course_id: this.lecture.course_id}})
                    }, 600);

                }).catch(error=>{
                    if (error && error.response && error.response.data){
                        const msg = error.response.data;
                        if (msg === 'EXAM_NOT_FOUND'){
                            this.showMsg('الامتحان غير موجود', 'error');
                        }else if (msg === 'EXAM_NOT_STARTED'){
                            this.showMsg('لم يبدأ الامتحان بعد، انتظر حتى يأتي وقت الامتحان', 'error');
                        }else if (msg === 'EXAM_ENDED'){
                            this.showMsg('انتهى الوقت المسموح فيه بدخول الامتحان', 'error');
                        }else{
                            this.showMsg('حدثت مشكلة أثناء جلب بيانات الامتحان', 'error');
                        }
                    }else{
                        this.showMsg('حدثت مشكلة أثناء جلب بيانات الامتحان', 'error');
                    }
                    this.openingExam = false;
                })
            }
        },
        backButtonHandler(){
            if (this.showVideoDialog){
                this.showVideoDialog = false;

            }else if (this.show){
                this.show = false;
            }else{
                if (this.$route.name === 'course'){
                    this.$router.go(-1);
                }
            }
        },
        ...GlobalMethods,
    },
    mounted(){
        if (this.capRunning){
            document.addEventListener('backbuttonclicked', this.backButtonHandler);
        }
    },
    beforeDestroy(){
        if (this.capRunning){
            document.removeEventListener('backbuttonclicked', this.backButtonHandler);
        }
    }
}
</script>

<style lang="scss">

</style>